import axios from "axios";
import * as cookie from '@static/js/cookieUtil.js';
import Vue from 'vue'

axios.defaults.timeout = 15 * 1000;

//拦截请求
axios.interceptors.request.use(
	config => {
		var userobj = window.sessionStorage.getItem('SC_USER');
		var token, userId, type;
		if (userobj != undefined && userobj != null && userobj != 'undefined') {
			var user = JSON.parse(userobj);
			token = user.token;
			userId = user.id;
			type = user.type;
		}
		if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers.common.token = `${token}`;
			config.headers.common.userId = `${userId}`;
		}
		return config;
	},
	err => {
		return Promise.reject(err);
	}
);

// 拦截响应response，并做一些错误处理
axios.interceptors.response.use((response) => {
	return response
}, (err) => { // 这里是返回状态码不为200时候的错误处理
	if (err && err.response) {
		switch (err.response.status) {
			case 404:
				err.message = `请求地址出错: ${err.response.config.url}`
				break;
			case 503:
				window.sessionStorage.removeItem("SC_USER");
        cookie.delCookie("SC_COOKIE_USER_ID");
        cookie.delCookie('SC_WX_USER_COOKIE');
        Vue.prototype.$alert('您的账号已在其他设备登录，请重新登录', '', ()=>{
          wx.closeWindow()
        })
				// weui.confirm('您的账号已在其他设备登录，点击确认重新登录', {
				// 	className: 's-k-weui-dlg',
				// 	title: '信息',
				// 	buttons: [{
				// 		label: 'close',
				// 		type: 'default',
				// 		onClick: function() {}
				// 	}, {
				// 		label: '取消',
				// 		type: 'default',
				// 		onClick: function() {}
				// 	}, {
				// 		label: '确认',
				// 		type: 'primary',
				// 		onClick: function() {
				// 			window.location.href = Vue.prototype.host;
				// 		}
				// 	}]
				// });
				return Promise.reject(err)
			case 1000:
				window.sessionStorage.removeItem("SC_USER");
        cookie.delCookie("SC_COOKIE_USER_ID");
        cookie.delCookie('SC_WX_USER_COOKIE');
        Vue.prototype.$alert('登录过期，请重新登录', '', ()=>{
          wx.closeWindow()
        })
				// weui.confirm('登录过期，点击确认重新登录', {
				// 	className: 's-k-weui-dlg',
				// 	title: '信息',
				// 	buttons: [{
				// 		label: 'close',
				// 		type: 'default',
				// 		onClick: function() {}
				// 	}, {
				// 		label: '取消',
				// 		type: 'default',
				// 		onClick: function() {}
				// 	}, {
				// 		label: '确认',
				// 		type: 'primary',
				// 		onClick: function() {
				// 			window.location.href = Vue.prototype.host;
				// 		}
				// 	}]
				// });
				return Promise.reject(err)
			default:
		}
	}
	var errStr = err.toString();
	if (errStr.indexOf('timeout') > -1) {
		return window.location.href = '/#/timeout';
	}
  // weui.alert('网络异常，请检查网络后重试');
  Vue.prototype.$toast.show('网络异常，请检查网络后重试')
	return Promise.reject(err);
});


export default axios;



// WEBPACK FOOTER //
// ./src/utils/axiosUtil.js